import type { UtilisateurCollectivite } from '../interfaces/utilisateurCollectivite';

const getBureauxUtilisateur = (utilisateur: UtilisateurCollectivite) => {
	const bureaux: string[] = [];

	utilisateur.collectivites.forEach((collectivite) => {
		collectivite.bureaux?.forEach((bureau) => {
			bureaux.push(`${bureau.name} - ${collectivite.libelle}`);
		});
	});

	return bureaux;
};

export default getBureauxUtilisateur;
